// extracted by mini-css-extract-plugin
export default {"button":"button_button__HzWwD","default":"button_default__o2oAM","loading":"button_loading__WDONq","loader":"button_loader__CepdB","rotation":"button_rotation__iIpoL"};